import { cn } from 'src/lib/utils';
import type { ExtractionStatus } from '../types/designer-exemplar.types';

const STATUS_STYLES: Record<ExtractionStatus, string> = {
  pending: 'bg-amber-100 text-amber-800',
  running: 'bg-blue-100 text-blue-800',
  succeeded: 'bg-[rgba(49,187,100,0.15)] text-[#31BB64]',
  failed: 'bg-red-101 text-red-700',
};

interface DesignerExemplarStatusBadgeProps {
  status: ExtractionStatus | string | null | undefined;
  className?: string;
}

export function DesignerExemplarStatusBadge({
  status,
  className,
}: DesignerExemplarStatusBadgeProps) {
  const key = (status ?? 'pending') as ExtractionStatus;
  const styleClass = STATUS_STYLES[key] ?? STATUS_STYLES.pending;

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium capitalize',
        styleClass,
        className,
      )}
    >
      {key}
    </span>
  );
}
